export default "__VITE_ASSET__11db8201__"